import React from 'react';
import './HeroSection.css';
import '../Progressivecommon.css';
import checkimg from '../assetsprogressive/checkimg.svg';

export default function HeroSection() {
  return (
    <div id='heroprogressive' className='progressive-wrapper'>
      <div className="main-container">
          <div className="left">
<h1 className='h1-tag'>Get funding in just 5 days</h1>
<ul>
    <li><img src={checkimg} alt="error" /><span>Effortless onboarding by directly syncing your details</span></li>
    <li><img src={checkimg} alt="error" /><span>Fully digital funding application process</span></li>
    <li><img src={checkimg} alt="error" /><span>Structured funding. No hard collaterals required</span></li>
</ul>
        </div>
        <div className="right">

        </div>
      </div>
    </div>
  )
}
